<form [formGroup]="paramFormWavesoftDevice" *ngIf="!readOnly">
  <mat-slide-toggle
    formControlName="sold">{{(this.paramFormWavesoftDevice.value.sold == 0 || this.paramFormWavesoftDevice.value.sold == null) ?
    ('AVAILABLE' | translate) : ('SOLD' | translate)}}</mat-slide-toggle>
</form>

<form *ngIf="readOnly">

  <mat-slide-toggle [disabled]="true"
                    [checked]="paramFormWavesoftDevice.value.sold == 1">{{(this.paramFormWavesoftDevice.value.sold == 0 || this.paramFormWavesoftDevice.value.sold == null) ?
    ('AVAILABLE' | translate) : ('SOLD' | translate)}}</mat-slide-toggle>
</form>
